ApiError = require 'network/api-error'
Auth = require 'db/auth'
Payloads = require 'network/payloads'
Enterprise = undefined
queueRequire -> Enterprise = require 'models/enterprise'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
log = require 'debug/log'
Promise = require 'bluebird'
$ = require 'jquery'
{ ErrorViews } = require 'common/data/error-views'
{ LDFlags, Tabs } = require 'views/enterprise/constants'
{ featureFlagClient } = require 'common/lib/feature-flag-client'

loadEnterpriseAdminDashboardView = ->
  `import(/* webpackChunkName: "enterprise-admin-dashboard-view" */'views/enterprise/enterprise-admin-dashboard-view')`

module.exports =
  routes: [
    ['e/:name/admin', 'enterpriseAdminDashboardView']
    ['e/:name/admin/*tab', 'enterpriseDashTab']
  ]

  displayEnterprisePage: (settings) ->
    { enterpriseName, viewClass, tab } = settings

    log('controller', ['enterprise'])

    Promise.using @getSpinner(), =>
      enterprise = ModelCache.findOne('Enterprise', 'name', enterpriseName)
      enterpriseIdOrName = enterprise?.id || enterpriseName

      Enterprise.load enterpriseIdOrName, Payloads.enterprise, ModelCache
      .then (enterprise) =>
        if tab? && (tab.startsWith(Tabs.SSO_SETTINGS) && !featureFlagClient.get(LDFlags.SSO_SELF_SERVE, false))
          @displayErrorPage()
          return

        # We need to check this here rather than at the beginning of the method
        # cause sometimes Auth.me() doesn't yet exist there, but it always
        # exists here.
        unless Auth.me().get('confirmed')
          @displayErrorPage
            errorType: ErrorViews.UNCONFIRMED_ENTERPRISE_NOT_FOUND
            email: Auth.me().get('email')
          return

        if !enterprise.isRealEnterprise()
          @displayErrorPage()
          return

        @clearPreviousView()
        @setViewType(enterprise)
        @showHeader()
        $('#classic-body').addClass('body-tabbed-page')

        options = { modelCache: ModelCache, initialTab: tab }
        enterpriseView = @topLevelView(viewClass, enterprise, options)
        $('#content').html(enterpriseView.render().el)

        title = enterprise.get('displayName')

        @setLocation
          title: title
          location: settings.getLocation.call(@, enterprise.get('name'), tab)

        return
      .catch ApiError, =>
        @displayErrorPage()
        return

  enterpriseAdminDashboardView: (enterpriseName) ->
    loadEnterpriseAdminDashboardView().then (EnterpriseAdminDashboardView) =>
      @displayEnterprisePage
        enterpriseName: enterpriseName
        viewClass: EnterpriseAdminDashboardView
        getLocation: @getEnterpriseAdminDashboardUrl
      .done()

  enterpriseDashTab: (enterpriseName, tab) ->
    allowedTabs = Object.values(Tabs)
    if tab not in allowedTabs
      @displayErrorPage()
      return

    loadEnterpriseAdminDashboardView().then (EnterpriseAdminDashboardView) =>
      @displayEnterprisePage
        enterpriseName: enterpriseName
        viewClass: EnterpriseAdminDashboardView
        getLocation: @getEnterpriseAdminDashboardUrl
        tab: tab
      .done()



// WEBPACK FOOTER //
// ./app/scripts/controller/enterprise-routes.coffee